// DS: IL3.6
import React from 'react';
export var PremiumTrash = function (_a) {
    var className = _a.className;
    return (React.createElement("img", { alt: "", src: "https://st.deviantart.net/eclipse/global/svg/il05-delete.svg", width: "90", height: "88", className: className }));
};
//# sourceMappingURL=PremiumTrash.js.map